import React from "react"
import styled from "styled-components"

import { minWidth, maxWidth } from "utils"

import Icon from "icons"

export const Header = styled.div`
  margin: 2rem 7.3rem 0;
  display: flex;
  justify-content: center;

  ${maxWidth.tablet`
    margin: 2rem 4rem 0;
  `}

  ${maxWidth.mobile`
    margin: 2rem 2rem 0;
  `}

  ${minWidth.hamburgerLarge`
    border-bottom: 0.15rem solid #222;
    justify-content: space-between;
  `}
`

const TitleText = styled.h1`
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 3.2rem;
  line-height: 4rem;

  ${minWidth.tablet`
    padding-bottom: 1.5rem;
    font-size: 4.6rem;
    line-height: 5rem;
  `}

  ::after {
    content: "${({ text }) => text}";
    position: relative;
    left: 0.5rem;
    font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 3rem;
    color: ${({ theme }) => theme.colors.primaryOrange};

    ${minWidth.tablet`
      left: 0.8rem;
      font-size: 3.8rem;
      line-height: 2.2rem;
    `}
  }
`

export const Title = ({ ...props }) => <TitleText {...props}>mindbodygreen</TitleText>

const SearchWrapper = styled.div`
  position: relative;
  display: none;

  ${minWidth.hamburgerLarge`
    display: block;
  `}
`

const SearchInput = styled.input`
  width: 34.2rem;
  padding-right: 5rem !important;
  border: 0.1rem solid #222 !important;
  border-radius: 10rem;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
  background-color: #fff !important;
  color: #767676;

  ::placeholder {
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.6rem;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
    color: #767676;
  }
`

const SearchIcon = styled(Icon)`
  position: absolute;
  top: 1.2rem;
  right: 2rem;
`

export const SearchBar = ({ ...props }) => (
  <SearchWrapper>
    <SearchInput type="text" placeholder="search" {...props} />
    <SearchIcon id="home-page-search" width={17} height={19} />
  </SearchWrapper>
)
